/**
 * Created by dri on 4/16/18.
 */
import * as _ from "lodash";
import * as $ from "jquery";
import {BaseGenericModal, BaseGenericModalOptions} from "./_BaseGenericModal";


interface GenericConfirmModalOptions extends BaseGenericModalOptions {
    cancelButtonText?: string;
    warning?: string;
}

export class GenericConfirmModal extends BaseGenericModal {
    public options: GenericConfirmModalOptions;
    private template = _.template(require('templates/modals/genericConfirm.html'));

    constructor(options: GenericConfirmModalOptions) {
        super(<any> _.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #genericConfirmModal': 'handleModalShown',
                'hidden.bs.modal #genericConfirmModal': 'handleModalHidden',
                'click .generic-confirm': 'handleConfirm'
            }
        }, options));
        this.genericIdSelector = 'genericConfirmModal';
    }

    render() {
        var cancelButtonText = this.options.cancelButtonText;
        var buttonText = this.options.buttonText;
        var titleText = this.options.titleText;
        var text = this.options.text;
        if(!cancelButtonText) {
            cancelButtonText = "No, Cancel"
        }
        if(!buttonText) {
            buttonText = "Yes, Confirm ";
        }
        if(!titleText) {
            titleText = 'Are you sure?';
        }
        if(!text) {
            text = 'Please Confirm by pressing a button';
        }

        this.$el.html(this.template({
            elementId: 'genericConfirmModal',
            cancelButtonText: cancelButtonText,
            buttonText: buttonText,
            titleText: titleText,
            text: text,
            warning: this.options.warning,
        }));
        return this;
    };

    handleConfirm() {
        this.setFormSubmitted();
        $.when(this.options.func()).done(() => {
            this.hide();
        });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/GenericConfirmModal.ts